export default __webpack_public_path__ + "static/media/activity-alarms.a5d7a716.svg";